<template>
  <div class="home">
    <!-- <h1>I design and code websites and stuff</h1> -->
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <div class="hello">
      <h1 class="intro">{{ this.chosenSlogan }}</h1>
      <!-- <button @click="picker">reload</button> -->
    </div>
    <!-- <HelloWorld msg="I develop logos and websites for people &amp; businesses"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    /*HelloWorld*/
  },
  data() {
    return {
      chosenNumber: '',
      chosenSlogan: '',
      slogans: [
      "I am the master of web and I shall master your web",
      "Is it time for something new?",
      "I create logos and websites for people & businesses",
      "Need help getting your online business started?",
      "Making the web a better place",
      "I develop engaging websites",
      "I'm here to help you succeed online",
      "Support your local web developer"
      ]
    };
  },
  methods: {
    picker: function(){
      var chosenNumber = Math.floor(Math.random() * this.slogans.length);
      this.chosenSlogan = this.slogans[chosenNumber];
      console.log(this.chosenSlogan);
    }
  },
  mounted() {
    this.picker()
  }
}
</script>
